// @flow
import React, { type Node } from 'react';

import VerificationsContext from './VerificationsContext';
import useVerificationsData from './useVerificationsData';


type Props = {
  solutionId?: number,
  children: Node,
}

const VerificationsData = ({ solutionId, children }: Props): Node => {
  const verificationsData = useVerificationsData(solutionId);

  return (
    <VerificationsContext.Provider value={verificationsData}>
      {children}
    </VerificationsContext.Provider>
  );
};

export default VerificationsData;
